<template>
  <div
    class="modalBlock"
    :class="[hasModalBackgroundImage ? 'modalBlock-hasBackgroundImage' : '']"
  >
    <order-header :is-payment="true" />
    <div class="modalHeaderBlock">
      <div class="headerTitle">
        {{ $t(`scan_and_go.title`) }}
      </div>
    </div>

    <select
      v-if="isDev"
      style="position: absolute; top: 0; left: 0; margin: 1rem; font-size: 22px"
      @change="applyDevBarcode"
      id="coupon-select"
    >
      <option value="">Apply DEV barcode</option>
      <option value='{"i":39,"u":143,"t":26,"s":"20250101","e":"20601231","c":1,"a":1.0}'>1€ off</option>
      <option value='{"i":39,"u":143,"t":26,"s":"20250101","e":"20601231","c":1,"a":10.0}'>10€ off</option>
      <option value='{"i":39,"u":143,"t":26,"s":"20250101","e":"20601231","c":1,"a":100.0}'>100€ off</option>
      <option value='{"i":39,"u":143,"t":26,"s":"20250101","e":"20601231","c":2,"a":10.0}'>10% off</option>
      <option value='{"i":39,"u":143,"t":26,"s":"20250101","e":"20601231","c":2,"a":50.0}'>50% off</option>
      <option value='{"i":39,"u":143,"t":26,"s":"20250101","e":"20601231","c":2,"a":100.0}'>100% off</option>
    </select>

    <div class="scannerWrapper">
      <div class="imageWrapper">
        <video loop autoplay muted :src="videoSrc('scan')" playsinline></video>
      </div>
      <div class="pictureSubtext" v-if="!barcode">
        <div>{{ $t(`scan_and_go.scan_code`) }}</div>
        <div class="small">{{ $t(`scan_and_go.scan_code_text`) }}</div>
      </div>
      <div v-else class="pictureSubtext">
        <div>{{ $t(`scan_and_go.scan_code`) }}</div>
        <div class="small" v-if="!success">Error: {{ error }}</div>
        <div class="small" v-if="success">
          {{ $t(`scan_and_go.scan_code_success`) }}
        </div>
      </div>
      <div v-if="barcode" class="scanSuccessWrapper">
        <video
          v-if="success"
          autoplay
          muted
          src="~@/assets/green_checkmark.webm"
          playsinline
        />
        <video
          v-if="!success"
          autoplay
          muted
          src="~@/assets/red_cross.webm"
          playsinline
        />
      </div>
      <div class="arrowBox">
        <video
          loop
          autoplay
          muted
          class="arrowImg"
          :src="videoSrc('arrows')"
          playsinline
        />
      </div>
    </div>

    <div class="actionBlock">
      <div class="closeBtn text" @click="closeModal">
        {{ $t(`edit.btn.close`) }}
      </div>
    </div>
  </div>
</template>

<script>
import OrderHeader from "@/components/order/OrderHeader.vue";
import { mapGetters } from "vuex";

import { endsWith, isEmpty } from "lodash";
import { COUPON_CATEGORIES, productPrice } from "@/utils/pricing";
import { coupon } from "@/api/payment";
import { isBackgroundImageSet, determineVideoSrc } from "@/utils/helpers";

const CATEGORY_MAP = {
  "6": { "1": 3, "2": 7, "3": 8, "4": 2 } //Freshfactory
};

export default {
  name: "coupon",
  components: {
    OrderHeader
  },
  computed: {
    ...mapGetters({
      basket: "BASKET",
      productByBarcode: "PRODUCT_BY_BARCODE",
      coupons: "COUPONS"
    }),
    hasModalBackgroundImage() {
      return isBackgroundImageSet(
        "--component_modals_scanandgo_modalBlock_background-image"
      );
    },
    isDev() {
      return process.env.NODE_ENV === 'development';
    }
  },
  created() {
    window.global_event_bus.$on("barcodeScanned", this.barcodeScanned);
  },
  beforeDestroy() {
    window.global_event_bus.$off("barcodeScanned", this.barcodeScanned);
  },
  data() {
    return {
      success: false,
      barcode: null,
      error: ""
    };
  },
  methods: {
    videoSrc(videoName) {
      return determineVideoSrc(
        "--component_modals_scanandgo_webm_key_",
        videoName
      );
    },
    barcodeScanned(barcode) {
      if (barcode.success) {
        if (barcode.verified) {
          this.handleCouponBarcode(barcode);
        } else {
          this.handleProductBarcode(barcode);
        }
      } else {
        if (barcode.verified) {
          this.failWithMessage(barcode, barcode.error);
        } else {
          this.failWithMessage(barcode, "InvalidBarcode");
        }
      }
    },
    handleProductBarcode(barcode) {
      let product = this.productByBarcode(barcode.barcode);
      if (product !== undefined) {
        this.barcode = barcode;
        this.success = true;
        this.error = "";
        console.log("Product Scanned:", product);

        if (endsWith(product.image, "empty.png") || isEmpty(product.image)) {
          product.image = require("@/assets/empty.png");
        }
        setTimeout(
          () => {
            this.closeModal();
          },
          this.success ? 2000 : 4000
        );
      } else {
        this.failWithMessage(barcode, "Unknown Product: " + barcode.barcode);
      }
    },
    handleCouponBarcode(barcode) {
      console.log("Scanandgo - handleCouponBarcode");
      if (
        barcode.data.u === 44 &&
        barcode.data.t === 5 &&
        barcode.data.i >= 5 &&
        barcode.data.i <= 504
      ) {
        // Ijsmakers: fix coupon category for indexes 5-504
        barcode.data.c = COUPON_CATEGORIES.PERCENT_OFF_CATEGORY;
      }
      if (
        barcode.data.c === COUPON_CATEGORIES.AMOUNT_OFF_CATEGORY ||
        barcode.data.c === COUPON_CATEGORIES.PERCENT_OFF_CATEGORY
      ) {
        let map = CATEGORY_MAP[barcode.data.u + ""];
        console.log("map:", map);
        barcode.data.p = barcode.data.p.map(c_id => {
          if (map && "" + c_id in map) {
            return map["" + c_id];
          }
          return c_id;
        });
        console.log(barcode);
        let selected;
        let saved = 0.0;
        this.basket.forEach(bi => {
          if (bi.selectedCombo) {
            //TODO: build something for Menus
          } else {
            //TODO: multiple coupons for items with a count > 1?
            if (
              !bi.coupon &&
              bi.categories.some(cat => {
                console.log("Testing:", bi.categories, barcode.data.p);
                console.log(
                  barcode.data.p.findIndex(c => c === cat.category) !== -1
                );
                return barcode.data.p.findIndex(c => c === cat.category) !== -1;
              })
            ) {
              let potentially_saved =
                barcode.data.c === COUPON_CATEGORIES.AMOUNT_OFF_CATEGORY
                  ? barcode.data.a
                  : (barcode.data.a / 100.0) * productPrice(bi);
              if (potentially_saved > saved) {
                saved = potentially_saved;
                selected = bi;
              }
            }
          }
        });
        if (!selected) {
          this.failWithMessage(barcode, "NotApplicable");
          return;
        }
        barcode.item = selected.uid;
      }
      if (barcode.data.c === COUPON_CATEGORIES.PERCENT_OFF) {
        //Check that there is only one of those!
        if (
          this.coupons.some(c => c.data.c === COUPON_CATEGORIES.PERCENT_OFF)
        ) {
          this.failWithMessage(barcode, "OnlyOneOfTypeAllowed");
          return;
        }
      }
      //we got a good barcode ask the payment system what it thinks about that....
      coupon(barcode.barcode)
        .then(ticket => {
          this.barcode = barcode;
          this.success = barcode.success;
          this.error = barcode.error;
          barcode.ticket = ticket;
          this.$emit("couponScanned", barcode);
          setTimeout(
            () => {
              this.closeModal();
            },
            this.success ? 2000 : 4000
          );
        })
        .catch(error => {
          this.failWithMessage(barcode, error.toString());
        });
    },
    failWithMessage(barcode, msg) {
      this.barcode = barcode;
      this.success = false;
      this.error = msg;
      setTimeout(() => {
        this.success = false;
        this.barcode = null;
        this.error = "";
      }, 3000);
    },
    closeModal() {
      this.$emit("close");
    },
    applyDevBarcode(event) {
      if (!event.target.value || process.env.NODE_ENV !== "development") return;
      const data = JSON.parse(event.target.value)

      const barcode = {
        barcode: event.target.value + ":_",
        success: true,
        verified: true,
        error: "",
        data: data
      }

      console.log("Applying DEV barcode:", barcode);

      this.handleCouponBarcode(barcode);

      event.target.value = "";
    }
  }
};
</script>

<style scoped>
.modalBlock {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 200;
  top: 0px;
  left: 0px;
  width: 1080px;
  height: 1920px;
  background: var(--component_modals_scanandgo_modalBlock_background);
}
.modalBlock-hasBackgroundImage {
  background-image: var(
    --component_modals_scanandgo_modalBlock_background-image
  );
}
.modalHeaderBlock {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}

.headerTitle {
  letter-spacing: 0;
  text-transform: uppercase;
  position: relative;
  z-index: 20;
  color: var(--component_modals_scanandgo_headerTitle_color);
  font-family: var(--component_modals_scanandgo_headerTitle_font-family);
  font-size: 45px;
  text-align: center;
  width: 600px;
  padding: 75px 0 125px;
}

.actionBlock {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 60px;
  margin-block: 80px;
}

.closeBtn {
  width: 210px;
  height: 70px;
  background: var(--component_modals_scanandgo_closeBtn_background);
  border-radius: var(--component_modals_scanandgo_closeBtn_border-radius);
  color: var(--component_modals_scanandgo_closeBtn_color);
  font-family: var(--component_modals_scanandgo_closeBtn_font-family);
  border: var(--component_modals_scanandgo_closeBtn_border);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--component_modals_scanandgo_closeBtn_font-size);
  padding: var(--component_modals_scanandgo_closeBtn_padding);
}

.scannerWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.pictureSubtext {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-family: var(--component_modals_scanandgo_pictureSubtext_font-family);
  font-size: var(--component_modals_scanandgo_pictureSubtext_font-size);
  margin: 20px;
  color: var(--component_modals_scanandgo_pictureSubtext_color);
  text-transform: var(
    --component_modals_scanandgo_pictureSubtext_text-transform
  );
}

.pictureSubtext .small {
  font-family: var(
    --component_modals_scanandgo_pictureSubtext_small_font-family
  );
  font-size: var(--component_modals_scanandgo_pictureSubtext_small_font-size);
  margin-top: 20px;
  text-transform: none;
}

.arrowImg {
  height: 125px;
}

.arrowBox {
  height: 100px;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 50px;
  display: flex;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
